import { useEffect, useReducer } from "react"
import { usePostData } from "../../../../../Hooks/FetchHooks/PostDataService/usePostData"

export const useFTP = (device, deviceConfigData) => {
	const { postItem } = usePostData()

	const initialState = {
		statusMessageContent: "",
		statusMessagePositive: null,
		showDisableButton: false,
		showPopup: false,
		isDisabledButton: false,
		openWarnningModal: false,
		isLoading: false,
		isSuccess: false,
		isError: false,
		isSyncError: false
	}

	const reducer = (state, action) => {
		switch (action.type) {
			case "IS_OFFLINE":
				return {
					...state,
					statusMessageContent: "The device is offline, FTP is not available",
					statusMessagePositive: null,
					showDisableButton: false,
					showPopup: false,
					isDisabledButton: true,
					isSyncError: true
				}
			case "CAN_DISABLE_FTP":
				return {
					...state,
					statusMessageContent: "FTP is running",
					statusMessagePositive: true,
					showDisableButton: true,
					showPopup: false,
					isDisabledButton: false,
					isSyncError: false
				}
			case "CAN_NOT_DISABLE_FTP":
				return {
					...state,
					statusMessageContent: "FTP is running",
					statusMessagePositive: true,
					showDisableButton: true,
					showPopup: true,
					isDisabledButton: true,
					isSyncError: false
				}
			case "DISABLED_FTP":
				return {
					...state,
					statusMessageContent: "FTP is disabled",
					statusMessagePositive: null,
					showDisableButton: false,
					showPopup: false,
					isSyncError: false,
					isDisabledButton: true
				}
			case "TOGGLE_MODAL":
				return {
					...state,
					openWarnningModal: action.payload,
					isError: false,
					isSuccess: false,
					isLoading: false
				}
			case "START_POSTING":
				return {
					...state,
					isLoading: true,
					isError: false,
					isSuccess: false,
					openWarnningModal: false,
					statusMessageContent: "Disabling ...",
					statusMessagePositive: null,
					showDisableButton: false,
					showPopup: false,
					isSyncError: false,
					isDisabledButton: true
				}
			case "POST_SUCCESS":
				return {
					...state,
					isSuccess: true,
					isLoading: false,
					isSyncError: false,
					statusMessageContent: "FTP is disabled",
					statusMessagePositive: null,
					showDisableButton: false,
					showPopup: false,
					isDisabledButton: true
				}
			case "POST_ERROR":
				return {
					...state,
					isError: true,
					isLoading: false,
					statusMessageContent: "Could not disable FTP",
					statusMessagePositive: false,
					showDisableButton: true,
					showPopup: false,
					isDisabledButton: false,
					isSyncError: false
				}
			case "IS_SYNC_ERROR":
				return {
					...state,
					isSyncError: true,
					showDisableButton: false,
					showPopup: false,
					isDisabledButton: true
				}
			default:
				return state
		}
	}

	const [state, dispatch] = useReducer(reducer, initialState)

	const openWarnningModal = (flag) => {
		dispatch({ type: "TOGGLE_MODAL", payload: flag })
	}

	const confirmHandler = () => {
		dispatch({ type: "START_POSTING" })
		postItem(
			"/api/v2/device/configure/ftp",
			{
				featureBitmap: 1,
				serialnumber: device.serialnr,
				is_enabled: false
			},
			null
		)
			.then(() => dispatch({ type: "POST_SUCCESS" }))
			.catch(() => dispatch({ type: "POST_ERROR" }))
	}

	const cancelHandler = () => {
		dispatch({ type: "TOGGLE_MODAL", payload: false })
	}

	useEffect(() => {
		switch (device.state) {
			case "offline":
				dispatch({ type: "IS_OFFLINE" })
				break
			case "idle":
				if (deviceConfigData.ftp_enabled) {
					dispatch({ type: "CAN_DISABLE_FTP" })
					break
				}
			case "busy":
			case "session":
				if (deviceConfigData.ftp_enabled) {
					dispatch({ type: "CAN_NOT_DISABLE_FTP" })
					break
				}
				dispatch({ type: "DISABLED_FTP" })
				break
		}
	}, [device, deviceConfigData])

	useEffect(() => {
		if (deviceConfigData.ftp_enabled == null) {
			dispatch({ type: "IS_SYNC_ERROR" })
		}
	}, [deviceConfigData])

	return { state, openWarnningModal, confirmHandler, cancelHandler }
}
